<template>
    <div class="countdownWrapper">
        {{ getCountdown() }} {{ unit }}
    </div>
</template>

<script>
    export default {
        name: 'Countdown',
        components: {},
        props: {
            progress: {
                type: Number,
                default: 1000,
            },
            goal: {
                type: Number,
                default: 15000,
            },
            unit: {
                type: String,
                default: '€',
            },
        },
        methods: {
            getCountdown () {
                return (this.progress - this.goal).toFixed(2);
            },
        },
    };
</script>

<style scoped>
    .countdownWrapper {
        font-size: 150px;
        letter-spacing: 5px;
        max-height: 180px;
    }
</style>
